<template>
    <div>
        <div class="d-flex justify-content-between">
            <span class="h4">{{transEdit('welcome')}} {{customername}}</span>
        </div>
        <hr>

        <div class="flex-fill p-2 d-flex justify-content-around flex-column flex-md-row text-center">
            <div>
                <a :href="route_book" class="btn btn-lg btn-block btn-outline-dark"><i class="fa fa-calendar-plus-o"></i> {{transEdit('book-treatment')}}</a>
            </div>
            <div class="mt-2 mt-md-0">
                <a :href="route_coupons" class="btn btn-lg btn-block btn-outline-dark"><i class="fa fa-ticket"></i> {{transEdit('buy-coupons')}}</a>
            </div>
        </div>

        <template v-if="this.part.company.subvention_amount">
            <hr>
            <div class='text-center h5' >
                Du har <span :class="subventionClass">{{subventionsLeft}}</span> subventioner kvar att boka för {{this.part.company.subvention_period > 0   ? 'i år' : 'denna månad'}}
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        props: [
            'part'
        ],
        name: "customer-dash-intro",
        computed: {
            customername() {
                return this.part.customername;
            },
            route_book() {
                return this.part.route_book;
            },
            route_settings() {
                return this.part.route_settings;
            },
            route_coupons() {
                return this.part.route_coupons;
            },
            subventionsLeft(){
                return this.part.company.subvention_amount - this.part.subventions;
            },
           subventionClass(){
                if(this.part.subventions <= this.part.company.subvention_amount){
                    return 'text-success';
                }

                return 'text-danger';
           }
        }
    }
</script>

<style scoped>

</style>